import { __rest } from "tslib";
import React, { useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import classnames from 'classnames';
import { Button, Form, Input, Popover, Select, Tooltip, InputNumber, Spin } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';
import { api, ProductTagEnum, ReminderAction } from 'api';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import moment, { isMoment } from 'moment';
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';
import lodashValues from 'lodash/values';
import throttle from 'lodash/throttle';
import cloneDeep from 'lodash/cloneDeep';
import styles from './createbox.module.scss';
import eventcontentStyles from '../EventContent/eventcontent.module.scss';
import { busyStatus, loopRules as baseLoopRules, clazzMap, EnmuRecurrenceRule, valiteMoment, isWeekday, constructAvailableMeetingRoomParam, parseRecurrenceRuleToFormRule, initDefaultMoment, reminderTimeUnitOpts, reminderActionOpts, getReminderByDefaultReminderAction, ReminderTimeUnit, } from './util';
import { addEvent, editEvent, getCatalogList, getMeetingRoomAvailabelList, getOneMeetingRoomInfo, getZoneId, getZoneList, queryFreeBusyList } from '../../service';
import { CatalogPrivilege, InviteType, ScheduleSendMailEnum } from '../../data';
import { getDateByForm, isCrossDay, senderMailToOriginInvitees } from '../../util';
import { RangeContent } from './PopContent';
import TimeStepPicker from '../TimeStepPicker/TimeStepPicker';
import pasteInputHoc, { PASTE_FLAG } from '../PasteInput/PasteInput';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { verifyEmail } from '@web-mail-write/util';
import Alert from '@web-common/components/UI/Alert/Alert';
import LocationInput from '../LocationInput/LocationInput';
import { rangeInteract } from '../TimeLinePicker/util';
import ArrowRight from '@web-common/components/UI/Icons/svgs/disk/ArrowRight';
import { transContactInfo2ContactItem } from '@web-common/components/util/contact';
import ContactScheduleModal from '@web-common/components/UI/SiriusContact/scheduleModal';
import ScheduleDatePicker from '../FormComponents/ScheduleDatePicker';
import { ScheduleActions, useActions, useAppSelector } from '@web-common/state/createStore';
import MeetingRoomUntilTip from './MeetingRoomUntilTip';
import { withProductAuthTag } from '@web-common/components/UI/ProductAuthTag/ProductAuthTag';
import InputContextMenu from '@web-common/components/UI/InputContextMenu/InputContextMenu';
import ScheduleUploadFile from './ScheduleUploadFile';
import CustomRepeat, { getRecurIntro } from './customRepeat';
import { getIn18Text } from 'api';
import { DescEditor } from './DescEditor';
import ScheduleTimezoneSelect from '@web-common/components/ScheduleTimeZoneSelect/scheduleTimeZoneSelect';
const FormItem = Form.Item;
const AuthTagSelect = withProductAuthTag(Select);
const AuthTagFormItem = withProductAuthTag(FormItem);
const PasteInput = pasteInputHoc(Input);
const PasteTextArea = pasteInputHoc(Input.TextArea);
const sysApi = api.getSystemApi();
const eventApi = api.getEventApi();
const isElectron = sysApi.isElectron();
const isEdm = sysApi.inEdm();
const storeApi = api.getDataStoreApi();
const queuedQueryFreeBusyList = async (param) => {
    const timestmp = Date.now();
    const data = await queryFreeBusyList(param);
    return {
        data,
        timestmp,
    };
};
export const genMaxLenValue = (props) => (e) => {
    let cutTipText = '';
    if (e.target[PASTE_FLAG]) {
        cutTipText = getIn18Text('\uFF0CYIWEININZI');
    }
    const value = e.target.value || '';
    if (value.length > props.max) {
        SiriusMessage.error({ content: `${props.name}最多为${props.max}字${cutTipText}` });
    }
    return value.slice(0, props.max);
};
export const valitedMeetingError = (code, onOk) => {
    let errorMsg = '';
    switch (code) {
        case 60202:
            errorMsg = getIn18Text('HUIYISHISHIJIAN11');
            break;
        case 60201:
            errorMsg = getIn18Text('GAIHUIYISHIYI11');
            break;
        case 60200:
        case 60300:
            errorMsg = getIn18Text('GAIHUIYISHIYI');
            break;
        default:
            break;
    }
    if (errorMsg !== '') {
        const al = Alert.info({
            title: errorMsg,
            okText: getIn18Text('ZHONGXINXUANZE'),
            width: 280,
            onOk: () => {
                al.destroy();
                if (onOk) {
                    onOk();
                }
            },
            okCancel: !0,
        });
        return true;
    }
    return false;
};
const formElementId = 'schdule_form_body';
const formElement = () => document.getElementById(formElementId) || document.body;
function ExpandButton(props) {
    const { onClick } = props;
    const [loading, setLoading] = useState(false);
    const handleClick = useCallback(debounce((e) => {
        setLoading(!0);
        onClick && onClick(e);
    }, 1000, {
        leading: true,
        trailing: false,
    }), [onClick]);
    return (React.createElement(Button, Object.assign({ loading: loading }, props, { onClick: handleClick })));
}
const limitWordCount = 2000;
const SchduleForm = ({ selectDate, onChange, meetingRoomExsit, onGoSelectMeetingRoom, onExpand, expanded, selectingMeetingRoom, meetingRoomChanged, onAfterSubmit, style, initValues, defaultContactList, defaultMoreInvitee, defaultMeetingTipType, defaultLoopRRules, onTimeRelatedValuesChange, formChangedMaunal, belongIdStr, reserveConfig, }, ref) => {
    var _a, _b, _c, _d;
    const [form] = Form.useForm();
    const [loopRules, setLoopRules] = useState(defaultLoopRRules || baseLoopRules);
    const autoFocusRef = useRef(null);
    const didianInputRef = useRef(null);
    const editorInstance = useRef(null);
    const [overLimit, setOverLimit] = useState(false);
    const [defaultReminders, setDefaultReminders] = useState([0]);
    const [editorContentChange, setEditorContentChange] = useState(false);
    const [meetingTipType, setMeetingTipType] = useState(defaultMeetingTipType);
    const [untilDateTimeTemp, setUntilDateTimeTemp] = useState();
    const [confirmProps, setConfirmProps] = useState({ visible: false });
    const [formSubmitCondition, setFormSubmitCondition] = useState(new Map());
    const { unSelectedCatalogIds, catalogList, scheduleEvent: editingEvent, creatDirectStartTime, creatDirectEndTime, scheduleEditFrom, } = useAppSelector(state => (Object.assign(Object.assign({}, state.scheduleReducer), { catalogList: state.scheduleReducer.catalogList.filter(e => (e.isOwner || e.privilege === CatalogPrivilege.OPREATE) && !e.syncAccountId) })));
    const { updateUnSelectedCatalogIds } = useActions(ScheduleActions);
    const uid = editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.uid;
    const [submiting, setSubmiting] = useState(false);
    const [userBusy, setUserBusy] = useState([]);
    const formCurStartDate = form.getFieldValue(['moments', 'startDate']);
    const formCurEndDate = form.getFieldValue(['moments', 'endDate']);
    const formCurStartTime = form.getFieldValue(['moments', 'startTime']);
    const formCurEndTime = form.getFieldValue(['moments', 'endTime']);
    const formCurAllDay = form.getFieldValue(['time', 'allDay']);
    const formCurUsers = form.getFieldValue('required') || [];
    const [durationError, setDurationError] = useState(false);
    const computeDurationError = (allDay, meetingOrderParam, startDate, startTime, endDate, endTime) => {
        const maxMinutes = reserveConfig === null || reserveConfig === void 0 ? void 0 : reserveConfig.maxReserveDuration;
        if (maxMinutes == null || maxMinutes <= 0)
            return false;
        if (allDay)
            return false;
        const hasMeetingRoom = !!(meetingRoomExsit && meetingOrderParam && meetingOrderParam.update_type !== 2);
        if (!hasMeetingRoom)
            return false;
        if (!isMoment(startDate) || !isMoment(endDate) || !isMoment(startTime) || !isMoment(endTime))
            return false;
        const start = getDateByForm(startDate, startTime, !!allDay);
        const end = getDateByForm(endDate, endTime, !!allDay);
        return end.getTime() - start.getTime() > maxMinutes * 60 * 1000;
    };
    useEffect(() => {
        const meetingOrderParam = form.getFieldValue('meetingOrderParam');
        setDurationError(computeDurationError(formCurAllDay, meetingOrderParam, formCurStartDate, formCurStartTime, formCurEndDate, formCurEndTime));
    }, [reserveConfig]);
    const [zoneList, setZoneList] = useState([]);
    const [offset, setOffset] = useState(undefined);
    useEffect(() => {
        if (autoFocusRef.current) {
            autoFocusRef.current.focus();
        }
    }, []);
    useEffect(() => {
        getZoneList().then(res => {
            var _a, _b;
            setZoneList(res);
            if (editingEvent) {
                const { scheduleInfo: { time, allDay }, } = editingEvent;
                if (!allDay) {
                    const zoneId = ((_a = time === null || time === void 0 ? void 0 : time.startZone) === null || _a === void 0 ? void 0 : _a.id) || ((_b = time === null || time === void 0 ? void 0 : time.endZone) === null || _b === void 0 ? void 0 : _b.id);
                    const selectedZone = res.find(zone => zone.id === zoneId);
                    if (selectedZone) {
                        setOffset(selectedZone.totalSeconds / 60);
                    }
                }
            }
        });
        if (!editingEvent) {
            const mailSysZone = sysApi.getSystemTimeZone();
            if (mailSysZone && mailSysZone.schedule_zone_id) {
                handleChangeZoneId(mailSysZone.schedule_zone_id);
            }
        }
    }, [editingEvent]);
    const queueFreebusy = useRef(0);
    const [gettingFreeBusyList, setGettingFreeBusyList] = useState(false);
    const throttledQueuedQueryFreeBusyListCallback = useCallback(throttle(async (param) => {
        setGettingFreeBusyList(true);
        try {
            const { timestmp, data } = await queuedQueryFreeBusyList(param);
            setGettingFreeBusyList(false);
            if (timestmp > queueFreebusy.current) {
                queueFreebusy.current = timestmp;
                setUserBusy(data);
            }
        }
        catch (error) {
            setGettingFreeBusyList(false);
        }
    }, 1000, { trailing: true, leading: true }), []);
    useEffect(() => {
        if (moment.isMoment(formCurStartDate) &&
            moment.isMoment(formCurEndDate) &&
            moment.isMoment(formCurStartTime) &&
            moment.isMoment(formCurEndTime) &&
            formCurUsers.length > 0) {
            const start = formCurAllDay
                ? formCurStartDate.clone().startOf('day')
                : formCurStartDate.clone().set({
                    hour: formCurStartTime.hours(),
                    minute: formCurStartTime.minutes(),
                    second: 0,
                    millisecond: 0,
                });
            const end = formCurAllDay
                ? formCurEndDate.clone().endOf('day')
                : formCurEndDate.clone().set({
                    hour: formCurEndTime.hours(),
                    minute: formCurEndTime.minutes(),
                    second: 0,
                    millisecond: 0,
                });
            throttledQueuedQueryFreeBusyListCallback({
                start: start.toDate(),
                end: end.toDate(),
                users: formCurUsers,
                uid,
            });
        }
    }, [formCurStartDate, formCurEndDate, formCurStartTime, formCurEndTime, formCurUsers, uid, formCurAllDay]);
    useEffect(() => {
        if (autoFocusRef.current) {
            autoFocusRef.current.focus();
        }
    }, []);
    const busyOutput = React.useMemo(() => {
        if (moment.isMoment(formCurStartDate) &&
            moment.isMoment(formCurEndDate) &&
            moment.isMoment(formCurStartTime) &&
            moment.isMoment(formCurEndTime) &&
            userBusy.length > 0) {
            const formStart = formCurAllDay
                ? formCurStartDate.clone().startOf('day')
                : formCurStartDate.clone().set({
                    hour: formCurStartTime.hours(),
                    minute: formCurStartTime.minute(),
                    second: 0,
                    millisecond: 0,
                });
            const formEnd = formCurAllDay
                ? formCurEndDate.clone().endOf('day')
                : formCurEndDate.clone().set({
                    hour: formCurEndTime.hours(),
                    minute: formCurEndTime.minute(),
                    second: 0,
                    millisecond: 0,
                });
            const userBusyStatusArr = userBusy.map(item => {
                let busy = false;
                for (let i = 0; i < item.freeBusyItems.length; i++) {
                    const element = item.freeBusyItems[i];
                    busy = rangeInteract([moment(element.start), moment(element.end)], [formStart, formEnd]) !== null;
                    if (busy) {
                        break;
                    }
                }
                return busy;
            });
            const busyCount = userBusyStatusArr.filter(e => e).length;
            let text = '';
            let status;
            if (busyCount === 0) {
                text = getIn18Text('DANGQIANCHENGYUANJUN');
                status = 'allFree';
            }
            else if (busyCount === userBusyStatusArr.length) {
                text = getIn18Text('SUOYOUCHENGYUANJUN');
                status = 'allBusy';
            }
            else {
                text = `${userBusyStatusArr.length}名成员中，${busyCount}人在忙`;
                status = 'partBusy';
            }
            return {
                text,
                status,
            };
        }
        return null;
    }, [userBusy, formCurStartTime, formCurEndTime, formCurStartDate, formCurEndDate, formCurAllDay]);
    useEffect(() => {
        var _a, _b, _c;
        if (!initValues) {
            const initenmuReminders = form.getFieldValue('reminders');
            const isAllDay = Boolean(form.getFieldValue(['time', 'allDay']));
            const reminders = getReminderByDefaultReminderAction(isAllDay);
            if (!editingEvent && Array.isArray(initenmuReminders) && initenmuReminders.length === 0) {
                form.setFieldsValue({
                    reminders: [reminders],
                });
            }
            else if ((_b = (_a = editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo) === null || _a === void 0 ? void 0 : _a.reminders) === null || _b === void 0 ? void 0 : _b.length) {
                form.setFieldsValue({
                    reminders: [
                        ...(_c = editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo) === null || _c === void 0 ? void 0 : _c.reminders.map(item => {
                            const newItem = Object.assign({}, item);
                            if (item.interval === 0) {
                                newItem.beforeOpt = 'current';
                            }
                            else {
                                newItem.beforeOpt = 'before';
                            }
                            return newItem;
                        }),
                    ],
                });
            }
        }
    }, [form, editingEvent, initValues]);
    useEffect(() => {
        let defaultSelectCatalog;
        if (editingEvent) {
            defaultSelectCatalog = catalogList.find(e => e.id === editingEvent.catalogInfo.id);
        }
        else {
            const myCatalogList = catalogList.filter(e => e.isOwner);
            for (let index = 0; index < myCatalogList.length; index++) {
                const catalog = myCatalogList[index];
                if (!unSelectedCatalogIds.includes(catalog.id)) {
                    defaultSelectCatalog = catalog;
                    break;
                }
            }
            if (!defaultSelectCatalog) {
                [defaultSelectCatalog] = catalogList;
            }
        }
        if (defaultSelectCatalog) {
            form.setFieldsValue({
                catalogId: Number(defaultSelectCatalog.id),
                color: defaultSelectCatalog.color,
            });
        }
        else {
            getCatalogList(!0).then(res => {
                if (res.length > 0) {
                    [defaultSelectCatalog] = res;
                    form.setFieldsValue({
                        catalogId: Number(defaultSelectCatalog.id),
                        color: defaultSelectCatalog.color,
                    });
                }
            });
        }
    }, []);
    const handleAfterSubmit = (data, msg) => {
        onAfterSubmit && onAfterSubmit(data, msg);
    };
    const resetSubmitingStatus = () => {
        setSubmiting(false);
        setFormSubmitCondition(new Map());
    };
    const handleSubmit = async (condition = formSubmitCondition) => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (submiting) {
            return;
        }
        setSubmiting(!0);
        const values = await form.validateFields();
        setConfirmProps({ visible: false });
        const actionText = getIn18Text('BAOCUNRICHENG');
        const actionState = getIn18Text('CHENGGONG');
        try {
            let res;
            if (editingEvent) {
                res = await editEvent(Object.assign(Object.assign({}, values), { description: (_a = editorInstance === null || editorInstance === void 0 ? void 0 : editorInstance.current) === null || _a === void 0 ? void 0 : _a.getContent() }), editingEvent, condition);
            }
            else {
                res = await addEvent(Object.assign(Object.assign({}, values), { senderMail: condition.get('senderMail'), description: (_b = editorInstance === null || editorInstance === void 0 ? void 0 : editorInstance.current) === null || _b === void 0 ? void 0 : _b.getContent() }), condition);
            }
            if (Number((_c = res.data) === null || _c === void 0 ? void 0 : _c.code) === 200) {
                handleAfterSubmit({
                    type: editingEvent ? 'update' : 'add',
                    data: editingEvent || values,
                }, `${actionText}${actionState}`);
                if (!editingEvent && unSelectedCatalogIds.some(id => +id === +values.catalogId)) {
                    const newUnSelectedCatalogIds = unSelectedCatalogIds.filter(id => +id !== +values.catalogId);
                    if (isElectron && expanded) {
                        await eventApi.sendSysEvent({
                            eventName: 'syncScheduleState',
                            eventData: {
                                reducerName: 'updateUnSelectedCatalogIds',
                                newState: newUnSelectedCatalogIds,
                            },
                        });
                    }
                    else {
                        updateUnSelectedCatalogIds(newUnSelectedCatalogIds);
                    }
                }
                if (isElectron && !editingEvent && belongIdStr) {
                    await eventApi.sendSysEvent({
                        eventName: 'syncScheduleState',
                        eventData: {
                            startDate: (_e = (_d = values === null || values === void 0 ? void 0 : values.moments) === null || _d === void 0 ? void 0 : _d.startTime) === null || _e === void 0 ? void 0 : _e.format('YYYY-MM-DD HH:mm:ss'),
                            summary: values === null || values === void 0 ? void 0 : values.summary,
                        },
                        eventStrData: belongIdStr,
                    });
                }
            }
            else {
                if (!valitedMeetingError((_f = res.data) === null || _f === void 0 ? void 0 : _f.code, () => {
                    onGoSelectMeetingRoom && onGoSelectMeetingRoom();
                })) {
                    SiriusMessage.error({ content: `${actionText}失败:${(_g = res.data) === null || _g === void 0 ? void 0 : _g.err_msg}` });
                }
                resetSubmitingStatus();
            }
        }
        catch (error) {
            SiriusMessage.error({ content: `${error}` });
            resetSubmitingStatus();
        }
    };
    const valiteUntil = (values) => {
        if (!values.moments.startDate) {
            return false;
        }
        if (values.rruleUntil && values.moments.startDate.isAfter(values.rruleUntil)) {
            SiriusMessage.error({
                content: getIn18Text('KAISHISHIJIANBU11'),
            });
            return false;
        }
        const attachmentsArr = values.attachments || [];
        if (attachmentsArr.length && attachmentsArr.some(f => f.status === 'uploading')) {
            message.error({
                content: getIn18Text('FUJIANSHANGCHUANZHONG11'),
                duration: 2,
            });
            return false;
        }
        return true;
    };
    const handleSave = async (inputcondition = formSubmitCondition) => {
        var _a, _b;
        const condition = new Map(inputcondition);
        const values = await form.validateFields();
        if (!valiteMoment(values.moments)) {
            return;
        }
        if (!valiteUntil(values)) {
            return;
        }
        const enmuRecurrenceRuleStr = (_a = values.enmuRecurrenceRule) === null || _a === void 0 ? void 0 : _a.split('/')[0];
        if (!condition.has('autoPrev') && enmuRecurrenceRuleStr === EnmuRecurrenceRule.MONTHLY && values.moments.startDate.date() > 28) {
            setConfirmProps(prev => (Object.assign(Object.assign({}, prev), { visible: !0, title: `不足${values.moments.startDate.date() > 28 ? values.moments.endDate.date() : values.moments.endDate.date()}日将自动安排到每月最后一天？`, content: (React.createElement("div", { className: styles.confirmButtons },
                    React.createElement(Button, { style: { marginLeft: 0, marginRight: 'auto' }, onClick: () => {
                            setConfirmProps({ visible: false });
                        } }, getIn18Text('JIXUBIANJI')),
                    React.createElement(Button, { onClick: () => {
                            condition.set('autoPrev', false);
                            handleSave(condition);
                        } }, getIn18Text('ZHIJIEBAOCUN')),
                    React.createElement(Button, { type: "primary", onClick: () => {
                            condition.set('autoPrev', true);
                            handleSave(condition);
                        } }, getIn18Text('ANPAI')))) })));
            return;
        }
        if (!condition.has('senderMail')) {
            if (values.required.length === 0 || (values.required.length === 1 && values.required[0] === ((_b = sysApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.id))) {
                condition.set('senderMail', ScheduleSendMailEnum.NOT_SEND);
                handleSave(condition);
                return;
            }
            setConfirmProps(prev => (Object.assign(Object.assign({}, prev), { visible: !0, title: getIn18Text('XIANGSHOUYAOCHENGYUAN'), content: (React.createElement("div", { className: styles.confirmButtons },
                    React.createElement(Button, { style: { marginLeft: 0, marginRight: 'auto' }, onClick: () => {
                            setConfirmProps({ visible: false });
                        } }, getIn18Text('JIXUBIANJI')),
                    React.createElement(Button, { onClick: () => {
                            condition.set('senderMail', ScheduleSendMailEnum.NOT_SEND);
                            handleSave(condition);
                        } }, getIn18Text('BUFASONG')),
                    React.createElement(Button, { type: "primary", onClick: () => {
                            condition.set('senderMail', ScheduleSendMailEnum.SEND);
                            handleSave(condition);
                        } }, getIn18Text('FASONG')))) })));
            return;
        }
        handleSubmit(condition);
    };
    const handleEdit = async (inputCondition = formSubmitCondition) => {
        var _a;
        if (!editingEvent) {
            return;
        }
        const condition = new Map(inputCondition);
        const values = await form.validateFields();
        if (!valiteMoment(values.moments)) {
            return;
        }
        if (!valiteUntil(values)) {
            return;
        }
        if (!condition.has('autoPrev') && values.enmuRecurrenceRule === EnmuRecurrenceRule.MONTHLY && values.moments.startDate.date() > 28) {
            setConfirmProps(prev => (Object.assign(Object.assign({}, prev), { visible: !0, title: `不足${values.moments.startDate.date() > 28 ? values.moments.endDate.date() : values.moments.endDate.date()}日将自动安排到每月最后一天？`, content: (React.createElement("div", { className: styles.confirmButtons },
                    React.createElement(Button, { style: { marginLeft: 0, marginRight: 'auto' }, onClick: () => {
                            setConfirmProps({ visible: false });
                        } }, getIn18Text('JIXUBIANJI')),
                    React.createElement(Button, { onClick: () => {
                            condition.set('autoPrev', false);
                            handleEdit(condition);
                        } }, getIn18Text('ZHIJIEBAOCUN')),
                    React.createElement(Button, { type: "primary", onClick: () => {
                            condition.set('autoPrev', true);
                            handleEdit(condition);
                        } }, getIn18Text('ANPAI')))) })));
            return;
        }
        if (!condition.has('range') && editingEvent.scheduleInfo.recurrenceId) {
            setConfirmProps(prev => (Object.assign(Object.assign({}, prev), { visible: !0, title: getIn18Text('QINGXUANZEGENGXIN'), content: (React.createElement(RangeContent, { item: editingEvent, hideThisAndFuture: editingEvent.scheduleInfo.inviteeType === InviteType.INVITEE || scheduleEditFrom === 'mail', hideThis: scheduleEditFrom === 'mail', onCancel: () => setConfirmProps({ visible: false }), onConfirm: e => {
                        condition.set('range', e);
                        handleEdit(condition);
                    } })) })));
            return;
        }
        if (!condition.has('senderMail') &&
            (editingEvent.scheduleInfo.inviteeType === InviteType.ORGANIZER || editingEvent.scheduleInfo.inviteeType === InviteType.INVITEE)) {
            const originInvitees = new Set(editingEvent.contactInfo.filter(e => e.originInvtees && !e.isOrganizer).map(e => e.email));
            const _originInvitees = new Set(originInvitees);
            const currentInvitees = new Set(values.required.filter(e => e !== editingEvent.scheduleInfo.organizer.extDesc));
            const moreInviteeMembers = new Set(values.moreInvitee.filter(e => { var _a; return e !== ((_a = sysApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id); }));
            values.required.forEach(id => {
                if (originInvitees.delete(id)) {
                    currentInvitees.delete(id);
                    moreInviteeMembers.delete(id);
                }
            });
            const hasAdded = currentInvitees.size > 0;
            const hasDeleted = originInvitees.size > 0;
            const hasAddMoreMembers = moreInviteeMembers.size > 0;
            const inviteeChanged = hasAdded || hasDeleted || hasAddMoreMembers;
            if (!inviteeChanged && values.required.length === 0) {
                condition.set('senderMail', ScheduleSendMailEnum.NOT_SEND);
                handleEdit(condition);
                return;
            }
            const titleTip = [];
            const keyParamChanged = senderMailToOriginInvitees(Object.assign(Object.assign({}, values), { description: (_a = editorInstance === null || editorInstance === void 0 ? void 0 : editorInstance.current) === null || _a === void 0 ? void 0 : _a.getContent() }), editingEvent, condition);
            const hasOriginInvitee = values.required.some(i => _originInvitees.has(i));
            if (hasAdded || hasAddMoreMembers) {
                titleTip.push(getIn18Text('XIANGXINZENGCHENGYUAN'));
            }
            if (hasDeleted) {
                titleTip.push(getIn18Text('XIANGBEISHANCHUDE'));
            }
            if (keyParamChanged && hasOriginInvitee) {
                titleTip.push(getIn18Text('XIANGYUANYOUCHENGYUAN'));
            }
            if (titleTip.length === 0) {
                condition.set('senderMail', ScheduleSendMailEnum.NOT_SEND);
                handleEdit(condition);
                return;
            }
            if (titleTip.length > 1) {
                titleTip[titleTip.length - 1] = getIn18Text('BING') + titleTip[titleTip.length - 1];
            }
            setConfirmProps(prev => (Object.assign(Object.assign({}, prev), { visible: !0, title: titleTip.join('，') + '？', content: (React.createElement("div", { className: styles.confirmButtons },
                    React.createElement(Button, { style: { marginLeft: 0, marginRight: 'auto' }, onClick: () => {
                            setConfirmProps({ visible: false });
                        } }, getIn18Text('JIXUBIANJI')),
                    React.createElement(Button, { onClick: () => {
                            condition.set('senderMail', ScheduleSendMailEnum.NOT_SEND);
                            handleEdit(condition);
                        } }, getIn18Text('BUFASONG')),
                    React.createElement(Button, { type: "primary", onClick: () => {
                            condition.set('senderMail', ScheduleSendMailEnum.SEND);
                            handleEdit(condition);
                        } }, getIn18Text('FASONG')))) })));
            return;
        }
        handleSubmit(condition);
    };
    const getMeetingCondition = (allValues) => {
        const { meetingOrderParam } = allValues;
        return (meetingRoomExsit &&
            ((meetingOrderParam !== undefined && meetingOrderParam.update_type !== 2) || ((editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.meetingInfo) && (meetingOrderParam === null || meetingOrderParam === void 0 ? void 0 : meetingOrderParam.update_type) !== 2)));
    };
    const handleCancelMeetingRoom = () => {
        var _a;
        let changedValues = {};
        if (editingEvent && editingEvent.scheduleInfo.meetingInfo) {
            const { room_id, order_id, date } = editingEvent.scheduleInfo.meetingInfo;
            changedValues = {
                meetingOrderParam: {
                    taken_date: date,
                    room_id,
                    order_id,
                    update_type: 2,
                },
                location: '',
            };
        }
        else {
            changedValues = {
                location: '',
                meetingOrderParam: undefined,
            };
        }
        form.setFieldsValue(changedValues);
        setMeetingTipType(undefined);
        const allValues = form.getFieldsValue();
        const allDay = !!((_a = allValues === null || allValues === void 0 ? void 0 : allValues.time) === null || _a === void 0 ? void 0 : _a.allDay);
        const { startDate, startTime, endDate, endTime } = (allValues === null || allValues === void 0 ? void 0 : allValues.moments) || {};
        setDurationError(computeDurationError(allDay, allValues === null || allValues === void 0 ? void 0 : allValues.meetingOrderParam, startDate, startTime, endDate, endTime));
        onChange && onChange(changedValues, Object.assign(Object.assign({}, form.getFieldsValue(!0)), changedValues));
    };
    const rruleNormalize = (v, prev) => {
        const startDate = form.getFieldValue(['moments', 'startDate']);
        form.setFieldsValue({ rruleUntil: undefined });
        if (v === EnmuRecurrenceRule.WEEKDAY && !isWeekday(startDate) && editingEvent) {
            SiriusMessage.error({ content: getIn18Text('KAISHIRIQIFEI') });
            return prev;
        }
        return v;
    };
    const resetReminders = React.useCallback((allDay) => {
        const reminder = getReminderByDefaultReminderAction(allDay);
        form.setFieldsValue({
            reminders: [reminder],
        });
    }, [form]);
    const handleStartDateChange = (startDate) => {
        if (startDate) {
            const moments = form.getFieldValue(['moments']);
            const endDate = moments.endDate.clone().set({
                year: startDate.year(),
                month: startDate.month(),
                date: startDate.date(),
            });
            const newFormFeildValues = {
                moments: Object.assign(Object.assign({}, moments), { endDate, startTime: startDate.clone(), endTime: endDate.clone() }),
            };
            form.setFieldsValue(newFormFeildValues);
        }
    };
    const handleEndDateChange = (endDate) => {
        var _a, _b;
        const allValues = form.getFieldsValue();
        const { meetingOrderParam, moments } = allValues;
        const curRoomId = (meetingOrderParam === null || meetingOrderParam === void 0 ? void 0 : meetingOrderParam.room_id) || ((_a = editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.meetingInfo) === null || _a === void 0 ? void 0 : _a.room_id);
        if (endDate) {
            if (isMoment(moments.endTime)) {
                const newFormFeildValues = {
                    moments: Object.assign(Object.assign({}, moments), { endTime: endDate.clone() }),
                };
                form.setFieldsValue(newFormFeildValues);
            }
            if (curRoomId && isMoment(moments.startDate) && isCrossDay(moments.startDate, endDate)) {
                const newEndDate = (_b = moments.endDate) === null || _b === void 0 ? void 0 : _b.clone().set({
                    year: moments.startDate.year(),
                    month: moments.startDate.month(),
                    date: moments.startDate.date(),
                });
                const newFormFeildValues = {
                    moments: Object.assign(Object.assign({}, moments), { endDate: newEndDate || null, endTime: isMoment(newEndDate) ? newEndDate.clone() : null }),
                };
                form.setFieldsValue(newFormFeildValues);
            }
        }
    };
    const handleChangeZoneId = (zoneId) => {
        form.setFieldsValue({ zoneId });
        const selectedZone = zoneList.find(zone => zone.id === zoneId);
        if (selectedZone) {
            setOffset(selectedZone.totalSeconds / 60);
        }
    };
    const handleAllDayChange = async (e) => {
        const { checked } = e.target;
        resetReminders(checked);
        if (!checked && editingEvent && editingEvent.scheduleInfo.allDay) {
            const moments = form.getFieldValue('moments');
            const { startDate, endDate } = moments;
            const zoneId = await getZoneId();
            const curMoment = moment();
            const curMin = curMoment.minutes();
            curMoment.minutes(curMin > 30 ? 60 : 30);
            const startTime = startDate.clone().hours(curMoment.hours()).minutes(curMoment.minutes());
            const endTime = endDate
                .clone()
                .hours(curMoment.hours() + 1)
                .minutes(curMoment.minutes());
            form.setFieldsValue({
                moments: Object.assign(Object.assign({}, moments), { startTime,
                    endTime, startDate: startTime.clone(), endDate: endTime.clone() }),
            });
            handleChangeZoneId(zoneId);
        }
    };
    const handleStartTimeChange = (startTime) => {
        if (isMoment(startTime)) {
            form.setFieldsValue({
                moments: {
                    startDate: startTime.clone(),
                },
            });
        }
        if (startTime && !(getMeetingCondition(form.getFieldsValue()) && startTime.minutes() % 30 !== 0)) {
            const prevEndTime = form.getFieldValue(['moments', 'endTime']);
            if (prevEndTime && prevEndTime.isAfter(startTime)) {
                return;
            }
            const endTime = startTime.clone().subtract(-1, 'hours');
            form.setFieldsValue({
                moments: {
                    endTime,
                    endDate: endTime.clone(),
                },
            });
        }
    };
    const handleEndTimeChange = (endTime) => {
        if (isMoment(endTime)) {
            const moments = form.getFieldValue('moments');
            form.setFieldsValue({
                moments: Object.assign(Object.assign({}, moments), { endDate: endTime.clone(), endTime }),
            });
        }
    };
    const timeNormalize = (name) => (v, prev) => {
        if (isEqual(name, ['moments', 'startDate']) && editingEvent) {
            const enmuRecur = form.getFieldValue('enmuRecurrenceRule');
            if (enmuRecur === EnmuRecurrenceRule.WEEKDAY && isMoment(v) && !isWeekday(v)) {
                SiriusMessage.info({ content: getIn18Text('KAISHIRIQIFEI') });
                return prev;
            }
        }
        if ((isEqual(name, ['moments', 'startTime']) || isEqual(name, ['moments', 'endTime'])) &&
            getMeetingCondition(form.getFieldsValue()) &&
            isMoment(v) &&
            v.minutes() % 15 !== 0) {
            SiriusMessage.info({ content: getIn18Text('HUIYISHISHIJIAN') });
            return prev;
        }
        return v;
    };
    const handleChangeCatalog = (catalogId) => {
        var _a;
        const color = (_a = catalogList.find(e => e.id === catalogId)) === null || _a === void 0 ? void 0 : _a.color;
        if (color) {
            form.setFieldsValue({ color });
        }
    };
    const handelRRuleChange = async (value) => {
        setLoopRules(baseLoopRules);
        if (value === EnmuRecurrenceRule.CUSTOM) {
            const allValues = form.getFieldsValue();
            const { meetingOrderParam, moments } = allValues;
            constructAvailableMeetingRoomParam(allValues, editingEvent).then(condtion => {
                var _a, _b;
                const curRoomId = (meetingOrderParam === null || meetingOrderParam === void 0 ? void 0 : meetingOrderParam.room_id) || ((_a = editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.meetingInfo) === null || _a === void 0 ? void 0 : _a.room_id);
                if (getMeetingCondition(allValues) && condtion && curRoomId) {
                    const recurrenceRule = { freq: 'DAILY', userFreq: 'DAILY', interval: 1 };
                    const params = Object.assign(Object.assign({}, condtion), { roomId: curRoomId, time: Object.assign(Object.assign({}, condtion.time), { recurrenceRule }) });
                    getOneMeetingRoomInfo(params).then(res => {
                        var _a;
                        const { statusCode, untilDate } = res;
                        if (statusCode === 1) {
                            const endDate = untilDate ? moment(untilDate) : moments.startDate.clone().add(3, 'month');
                            (_a = customRepeatRef.current) === null || _a === void 0 ? void 0 : _a.showCustomRepeat(moments.startDate.clone(), endDate);
                        }
                    });
                }
                else {
                    (_b = customRepeatRef.current) === null || _b === void 0 ? void 0 : _b.showCustomRepeat(moments.startDate.clone());
                }
            });
        }
        if (value && value !== EnmuRecurrenceRule.NONE && value !== EnmuRecurrenceRule.CUSTOM) {
            form.setFieldsValue({ interval: undefined, count: undefined });
        }
    };
    const customRepeatRef = useRef(null);
    useEffect(() => {
        var _a, _b;
        if (initValues) {
            if (defaultMeetingTipType === 'until_error') {
                setUntilDateTimeTemp((initValues.moments.startDate || moment()).clone().add(3, 'month'));
            }
            return form.setFieldsValue(initValues);
        }
        if (editingEvent) {
            const { scheduleInfo: { transp, clazz, description, summary, attachments = [], reminders, allDay, start, end, recur, location, time, }, contactInfo, } = editingEvent;
            const initialValues = {
                summary,
                transp,
                clazz,
                location,
                description,
                reminders,
                required: contactInfo.filter(e => e.originInvtees).map(e => e.email),
                time: {
                    allDay,
                },
                attachments,
            };
            if (!allDay) {
                initialValues.zoneId = ((_a = time === null || time === void 0 ? void 0 : time.startZone) === null || _a === void 0 ? void 0 : _a.id) || ((_b = time === null || time === void 0 ? void 0 : time.endZone) === null || _b === void 0 ? void 0 : _b.id);
            }
            if (recur) {
                if (recur.until) {
                    initialValues.rruleUntil = moment({
                        year: recur.until.y,
                        month: recur.until.m - 1,
                        date: recur.until.d,
                        hour: recur.until.hr,
                        minute: recur.until.min,
                        second: recur.until.sec,
                    });
                }
                if (recur.count) {
                    initialValues.count = recur.count;
                }
                initialValues.interval = recur.interval;
                initialValues.byDay = recur.byDay;
                initialValues.byMonth = recur.byMonth;
                initialValues.byMonthDay = recur.byMonthDay;
                initialValues.bySetPos = recur.bySetPos;
                const getRecur = parseRecurrenceRuleToFormRule(recur);
                if (getRecur === EnmuRecurrenceRule.TEMP_INSERT) {
                    const actRuleValue = `${recur === null || recur === void 0 ? void 0 : recur.freq}/${EnmuRecurrenceRule.TEMP_INSERT}`;
                    const actLoopRules = baseLoopRules.slice();
                    actLoopRules.push({
                        value: actRuleValue,
                        label: recur.recurIntro || '自定义重复',
                    });
                    initialValues.enmuRecurrenceRule = actRuleValue;
                    setLoopRules(actLoopRules);
                }
                else {
                    initialValues.enmuRecurrenceRule = getRecur;
                }
            }
            const startMoment = moment(start);
            const endMoment = moment(end);
            if (allDay && endMoment.diff(startMoment) > 0) {
                endMoment.add(-1, 'day');
            }
            form.setFieldsValue(Object.assign(Object.assign({}, initialValues), { moments: {
                    startDate: startMoment.clone(),
                    endDate: endMoment.clone(),
                    startTime: startMoment.clone(),
                    endTime: endMoment.clone(),
                } }));
        }
        else if (selectDate) {
            if (selectDate.view.type !== 'dayGridMonth') {
                const timeGridWeekInitEnd = moment(selectDate.end);
                if (selectDate.allDay) {
                    timeGridWeekInitEnd.subtract(1, 'day');
                }
                form.setFieldsValue({
                    moments: {
                        startDate: moment(selectDate.start).clone(),
                        endDate: timeGridWeekInitEnd.clone(),
                        startTime: moment(selectDate.start).clone(),
                        endTime: timeGridWeekInitEnd.clone(),
                    },
                    time: {
                        allDay: selectDate.allDay ? 1 : 0,
                    },
                    reminders: [getReminderByDefaultReminderAction(Boolean(selectDate.allDay))],
                });
            }
            else {
                const curMoment = moment();
                const startMoment = moment(selectDate.start);
                const endMoment = moment(selectDate.end);
                const curMin = curMoment.minutes();
                curMoment.minutes(curMin > 30 ? 60 : 30);
                endMoment.date(endMoment.date() - 1);
                startMoment.hours(curMoment.hours()).minutes(curMoment.minutes());
                endMoment.hours(curMoment.hours() + 1);
                form.setFieldsValue({
                    moments: {
                        startDate: startMoment.clone(),
                        endDate: endMoment.clone(),
                        startTime: startMoment.clone(),
                        endTime: endMoment.clone(),
                    },
                });
            }
        }
        else {
            const defaultMoments = initDefaultMoment();
            const startDate = isMoment(creatDirectStartTime) ? creatDirectStartTime.clone() : defaultMoments.startDate;
            const endDate = isMoment(creatDirectEndTime) ? creatDirectEndTime.clone() : defaultMoments.endDate;
            const startTime = isMoment(creatDirectStartTime) ? creatDirectStartTime.clone() : defaultMoments.startTime;
            const endTime = isMoment(creatDirectEndTime) ? creatDirectEndTime.clone() : defaultMoments.endTime;
            form.setFieldsValue({
                moments: {
                    startDate,
                    endDate,
                    startTime,
                    endTime,
                },
            });
        }
        if (!editingEvent) {
            const mailSysZone = sysApi.getSystemTimeZone();
            if (mailSysZone && mailSysZone.schedule_zone_id) {
                handleChangeZoneId(mailSysZone.schedule_zone_id);
            }
        }
        return () => { };
    }, [selectDate, form, editingEvent, initValues]);
    useImperativeHandle(ref, () => ({
        getFormInstance: () => form,
        getMeetingTipType: () => meetingTipType,
        getLoopRRules: () => loopRules,
        resetReminders,
        recomputeDurationError: () => {
            var _a;
            const allValues = form.getFieldsValue();
            const allDay = !!((_a = allValues === null || allValues === void 0 ? void 0 : allValues.time) === null || _a === void 0 ? void 0 : _a.allDay);
            const { startDate, startTime, endDate, endTime } = (allValues === null || allValues === void 0 ? void 0 : allValues.moments) || {};
            setDurationError(computeDurationError(allDay, allValues === null || allValues === void 0 ? void 0 : allValues.meetingOrderParam, startDate, startTime, endDate, endTime));
        },
    }));
    const initialValues = initValues || {
        summary: '',
        enmuRecurrenceRule: loopRules[0].value,
        transp: busyStatus[0].value,
        clazz: clazzMap[0].value,
        required: defaultContactList && (defaultContactList === null || defaultContactList === void 0 ? void 0 : defaultContactList.length) > 0 ? defaultContactList.map(e => e.email) : [],
        reminders: [],
        moreInvitee: [],
    };
    const renderSaveBtn = () => (React.createElement(Popover, Object.assign({}, confirmProps, { trigger: "click", overlayClassName: styles.confirmOverlay, onVisibleChange: v => {
            setConfirmProps({
                visible: v,
            });
        } }),
        React.createElement(Button, { disabled: meetingTipType !== undefined || durationError || (!editorContentChange && !formChangedMaunal && !!editingEvent), loading: submiting, type: "primary", onClick: () => {
                if (!window.navigator.onLine) {
                    return SiriusMessage.netWorkError();
                }
                return editingEvent ? handleEdit() : handleSave();
            } }, getIn18Text('BAOCUN'))));
    useEffect(() => {
        var _a;
        if (!selectingMeetingRoom) {
            const allValues = form.getFieldsValue();
            const { enmuRecurrenceRule, meetingOrderParam, moments, rruleUntil } = allValues;
            const curRoomId = (meetingOrderParam === null || meetingOrderParam === void 0 ? void 0 : meetingOrderParam.room_id) || ((_a = editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.meetingInfo) === null || _a === void 0 ? void 0 : _a.room_id);
            const willBeRecEvent = enmuRecurrenceRule !== EnmuRecurrenceRule.NONE;
            constructAvailableMeetingRoomParam(allValues, editingEvent).then(condtion => {
                if (getMeetingCondition(allValues) && curRoomId && willBeRecEvent && condtion) {
                    const params = Object.assign(Object.assign({}, condtion), { roomId: curRoomId });
                    getOneMeetingRoomInfo(params)
                        .then(res => {
                        const { statusCode, untilDate } = res;
                        if (statusCode === 1 || statusCode === 2) {
                            const untilDateMoment = untilDate ? moment(untilDate) : moments.startDate.clone().add(3, 'month');
                            if (untilDateMoment.isBefore(rruleUntil) || rruleUntil === undefined) {
                                setUntilDateTimeTemp(untilDateMoment);
                                setMeetingTipType('until_error');
                            }
                        }
                        else if (statusCode === 3) {
                            setMeetingTipType('all_room_invalid');
                        }
                    })
                        .catch(() => {
                        setMeetingTipType('all_room_invalid');
                    });
                }
            });
        }
    }, [selectingMeetingRoom, meetingRoomChanged]);
    const handleValuesChange = (changedValues, _allValues) => {
        var _a;
        if (onChange) {
            onChange(changedValues, _allValues);
        }
        if (changedValues.moments || changedValues.time || changedValues.meetingOrderParam) {
            const allDay = !!((_a = _allValues === null || _allValues === void 0 ? void 0 : _allValues.time) === null || _a === void 0 ? void 0 : _a.allDay);
            const { startDate, startTime, endDate, endTime } = (_allValues === null || _allValues === void 0 ? void 0 : _allValues.moments) || {};
            setDurationError(computeDurationError(allDay, _allValues === null || _allValues === void 0 ? void 0 : _allValues.meetingOrderParam, startDate, startTime, endDate, endTime));
        }
        if (changedValues.enmuRecurrenceRule === EnmuRecurrenceRule.NONE) {
            setMeetingTipType(undefined);
        }
        if (['moments', 'time'].filter(key => changedValues[key]).length) {
            setTimeout(() => {
                onTimeRelatedValuesChange === null || onTimeRelatedValuesChange === void 0 ? void 0 : onTimeRelatedValuesChange(form.getFieldsValue());
            }, 1);
        }
        if (['enmuRecurrenceRule', 'meetingOrderParam', 'moments', 'rruleUntil'].filter(key => changedValues[key]).length === 0) {
            return;
        }
        if (changedValues.enmuRecurrenceRule === EnmuRecurrenceRule.CUSTOM) {
            return;
        }
        if (changedValues.moments && !lodashValues(changedValues.moments).every(isMoment)) {
            return;
        }
        setTimeout(async () => {
            var _a, _b;
            const allValues = form.getFieldsValue();
            const { enmuRecurrenceRule, meetingOrderParam, moments, rruleUntil } = allValues;
            const condtion = await constructAvailableMeetingRoomParam(allValues, editingEvent);
            const curRoomId = (meetingOrderParam === null || meetingOrderParam === void 0 ? void 0 : meetingOrderParam.room_id) || ((_a = editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.meetingInfo) === null || _a === void 0 ? void 0 : _a.room_id);
            const willBeRecEvent = enmuRecurrenceRule !== EnmuRecurrenceRule.NONE;
            if (getMeetingCondition(allValues) && condtion && curRoomId) {
                if (willBeRecEvent) {
                    const params = Object.assign(Object.assign({}, condtion), { roomId: curRoomId });
                    const res = await getOneMeetingRoomInfo(params);
                    const { statusCode, untilDate } = res;
                    if (statusCode === 1 || statusCode === 2) {
                        const untilDateMoment = untilDate ? moment(untilDate) : moments.startDate.clone().add(3, 'month');
                        if (untilDateMoment.isBefore(rruleUntil) || rruleUntil === undefined) {
                            setUntilDateTimeTemp(untilDateMoment);
                            setMeetingTipType('until_error');
                        }
                    }
                    else if (statusCode === 3) {
                        setMeetingTipType('all_room_invalid');
                    }
                }
                if (changedValues.moments || ((_b = changedValues.time) === null || _b === void 0 ? void 0 : _b.allDay) || changedValues.enmuRecurrenceRule) {
                    getMeetingRoomAvailabelList(condtion)
                        .then(list => {
                        if (list.length === 0) {
                            setMeetingTipType('all_room_invalid');
                            return;
                        }
                        if (!list.some(e => e.roomInfo.room_id + '' === curRoomId + '')) {
                            setMeetingTipType('cur_room_invalid');
                        }
                    })
                        .catch(() => {
                        setMeetingTipType('all_room_invalid');
                    });
                }
            }
        }, 1);
    };
    const handleCustomRepeatOk = (obj) => {
        const { rruleUntil, interval, enmuRecurrenceRule, count, byDay, byMonth, byMonthDay, bySetPos, recurIntro } = obj;
        const changedValues = {
            interval,
            enmuRecurrenceRule: `${enmuRecurrenceRule}/${EnmuRecurrenceRule.TEMP_INSERT}`,
        };
        if (count) {
            changedValues.count = count;
        }
        if (rruleUntil) {
            changedValues.rruleUntil = rruleUntil;
        }
        if (byDay) {
            changedValues.byDay = byDay;
        }
        if (byMonth) {
            changedValues.byMonth = byMonth;
        }
        if (byMonthDay) {
            changedValues.byMonthDay = byMonthDay;
        }
        if (bySetPos) {
            changedValues.bySetPos = bySetPos;
        }
        form.setFieldsValue(changedValues);
        const allValues = Object.assign(Object.assign({}, form.getFieldsValue()), changedValues);
        const actRules = baseLoopRules.slice();
        actRules.push({
            value: `${enmuRecurrenceRule}/${EnmuRecurrenceRule.TEMP_INSERT}`,
            label: recurIntro,
        });
        setLoopRules(actRules);
        handleValuesChange(changedValues, allValues);
    };
    const handleCustomRepeatCancel = () => {
        form.setFieldsValue({ enmuRecurrenceRule: EnmuRecurrenceRule.NONE });
    };
    const editorChange = () => {
        const wordCount = getWordCount();
        setEditorContentChange(wordCount !== 0);
        setOverLimit(wordCount > limitWordCount);
    };
    const editorBlur = () => {
    };
    const getWordCount = () => {
        if (editorInstance === null || editorInstance === void 0 ? void 0 : editorInstance.current) {
            return (editorInstance === null || editorInstance === void 0 ? void 0 : editorInstance.current.plugins.wordcount.body.getCharacterCount()) || 0;
        }
        return 0;
    };
    const handleBeforeOptChange = useCallback((item, idx) => {
        var _a;
        const reminders = form.getFieldValue('reminders');
        if (reminders[idx]) {
            if (item === 'current') {
                reminders[idx].interval = 0;
            }
            else if (((_a = reminders[idx]) === null || _a === void 0 ? void 0 : _a.interval) === 0) {
                reminders[idx].interval = 1;
            }
            form.setFieldsValue({ reminders });
        }
    }, [form]);
    const handleIntervalChange = useCallback((item, idx) => {
        const reminders = form.getFieldValue('reminders');
        let val = item;
        let isValid = true;
        if (!reminders[idx]) {
            return;
        }
        const timeUnit = reminders[idx].timeUnit;
        const reminderAction = reminders[idx].reminderAction;
        let maxLength = ReminderTimeUnit.DAY === timeUnit ? 7 : ReminderTimeUnit.HOUR === timeUnit ? 24 : 60;
        if (!Number.isInteger(val)) {
            val = Math.floor(val);
            isValid = false;
        }
        if (val === 0) {
            val = 1;
            isValid = false;
        }
        else if (val > maxLength) {
            val = maxLength;
            isValid = false;
        }
        if (!isValid) {
            reminders[idx].interval = val;
            form.setFieldsValue({ reminders });
        }
        if (reminderAction !== ReminderAction.EMAIL && ReminderTimeUnit.WEEK === timeUnit && val > 4) {
            reminders[idx].reminderAction = ReminderAction.EMAIL;
            form.setFieldsValue({ reminders });
        }
    }, [form]);
    const getEditorInstance = (editor) => {
        editorInstance.current = editor;
    };
    const handleExpand = () => {
        onExpand && onExpand(!0);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames(styles.body, {
                [styles.bodyExpanded]: expanded,
            }), id: formElementId, style: style },
            React.createElement(Spin, { spinning: gettingFreeBusyList && (userBusy === null || userBusy === void 0 ? void 0 : userBusy.length) === 0 },
                React.createElement(Form, { form: form, colon: false, initialValues: initialValues, onValuesChange: handleValuesChange },
                    React.createElement(InputContextMenu, { inputOutRef: autoFocusRef, changeVal: val => {
                            form.setFieldsValue({ summary: val });
                        } },
                        React.createElement(FormItem, { getValueFromEvent: genMaxLenValue({ max: 300, name: getIn18Text('RICHENGZHUTI') }), name: "summary", label: React.createElement("i", { className: classnames(eventcontentStyles.icon, eventcontentStyles.summry) }) },
                            React.createElement(PasteInput, { allowClear: true, ref: autoFocusRef, placeholder: getIn18Text('RICHENGZHUTI'), className: styles.titleInput }))),
                    React.createElement(FormItem, { label: React.createElement("i", { className: classnames(eventcontentStyles.icon, eventcontentStyles.clock) }), dependencies: [['time', 'allDay']] }, ({ getFieldValue }) => {
                        var _a;
                        const allDay = getFieldValue(['time', 'allDay']);
                        const _startDate = getFieldValue(['moments', 'startDate']) || moment();
                        const _startTime = getFieldValue(['moments', 'startTime']) || moment();
                        const _endDate = getFieldValue(['moments', 'endDate']) || moment();
                        const _endTime = getFieldValue(['moments', 'endTime']) || moment();
                        const start = getDateByForm(_startDate, _startTime, allDay);
                        const end = getDateByForm(_endDate, _endTime, allDay);
                        return (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: classnames(styles.timeWrapper, { [styles.timeWrapperError]: durationError }), style: {
                                    justifyContent: allDay ? 'flex-start' : 'space-between',
                                } },
                                React.createElement(FormItem, { normalize: timeNormalize(['moments', 'startDate']), name: ['moments', 'startDate'], noStyle: true },
                                    React.createElement(ScheduleDatePicker, { disabled: (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE, onChange: handleStartDateChange, className: styles.datePicker, offset: offset })),
                                React.createElement(FormItem, { noStyle: true, normalize: timeNormalize(['moments', 'startTime']), hidden: allDay, name: ['moments', 'startTime'] },
                                    React.createElement(TimeStepPicker, { disabled: (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE, className: styles.timePicker, onChange: handleStartTimeChange, offset: offset })),
                                React.createElement("span", { className: styles.timeSplit, style: {
                                        padding: allDay ? '0 8px' : 0,
                                    } }, "\u2014\u2014"),
                                React.createElement(FormItem, { normalize: timeNormalize(['moments', 'endDate']), noStyle: true, name: ['moments', 'endDate'] },
                                    React.createElement(ScheduleDatePicker, { disabled: (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE, onChange: handleEndDateChange, className: styles.datePicker, offset: offset })),
                                React.createElement(FormItem, { normalize: timeNormalize(['moments', 'endTime']), noStyle: true, hidden: allDay, name: ['moments', 'endTime'] },
                                    React.createElement(TimeStepPicker, { onChange: handleEndTimeChange, disabled: (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE, className: styles.timePicker, offset: offset }))),
                            React.createElement("div", { className: styles.formTimezoneSelect, hidden: allDay },
                                React.createElement(FormItem, { noStyle: true, name: "zoneId" },
                                    React.createElement(Select, { showSearch: true, disabled: (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE, dropdownClassName: styles.selectDropDown, listItemHeight: 30, style: { width: '100%' }, filterOption: (input, option) => ((option === null || option === void 0 ? void 0 : option.label) || '').toLowerCase().includes(input.toLowerCase()), onChange: handleChangeZoneId, options: zoneList.map(zoneItem => ({ value: zoneItem.id, label: `${zoneItem.content} ${zoneItem.key}` })) }))),
                            React.createElement("div", { className: styles.formTimezoneSelect },
                                React.createElement(ScheduleTimezoneSelect, { bordered: false, showTimeDiffLabel: true, localZoneStartTime: start, localZoneEndTime: end, allDay: allDay, durationTextLabelStyle: { paddingLeft: 12 } })),
                            durationError && (React.createElement("div", { className: styles.durationErrorTip }, getIn18Text('单次日程时长不可超过{minutes}分钟，如有特殊需要，请联系管理员！', {
                                minutes: (_a = reserveConfig === null || reserveConfig === void 0 ? void 0 : reserveConfig.maxReserveDuration) !== null && _a !== void 0 ? _a : 0,
                            })))));
                    }),
                    React.createElement(FormItem, { label: React.createElement("i", { className: classnames(eventcontentStyles.icon) }) },
                        React.createElement(FormItem, { dependencies: [['moment', 'startDate'], ['rruleUntil']], normalize: rruleNormalize, noStyle: true, name: "enmuRecurrenceRule" },
                            React.createElement(AuthTagSelect, { authTagProps: {
                                    tagName: ProductTagEnum.SCHEDULE_SETTING,
                                    tipText: getIn18Text('XIANSHI'),
                                    flowTipStyle: {
                                        left: 'calc(100% - 42px)',
                                    },
                                }, dropdownMatchSelectWidth: false, id: "schedule_form_select_rrule", getPopupContainer: expanded ? formElement : undefined, disabled: (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE, onChange: handelRRuleChange, dropdownClassName: styles.selectDropDown, listItemHeight: 30, style: { width: 200, marginRight: 12 }, suffixIcon: React.createElement("i", { className: `dark-invert ${styles.expandIcon}` }) }, loopRules.map(r => (React.createElement(Select.Option, { className: styles.selectOption, key: r.value, value: r.value }, r.label))))),
                        React.createElement(CustomRepeat, { onOk: handleCustomRepeatOk, onCancel: handleCustomRepeatCancel, ref: customRepeatRef }),
                        React.createElement(FormItem, { noStyle: true, shouldUpdate: (prev, cur) => prev.meetingOrderParam !== cur.meetingOrderParam }, () => {
                            const maxMinutes = reserveConfig === null || reserveConfig === void 0 ? void 0 : reserveConfig.maxReserveDuration;
                            const hasSelectedRoom = !!getMeetingCondition(form.getFieldsValue());
                            const allDayDisabled = maxMinutes != null && maxMinutes > 0 && hasSelectedRoom;
                            return (React.createElement(FormItem, { noStyle: true, normalize: timeNormalize(['time', 'allDay']), valuePropName: "checked", name: ['time', 'allDay'] },
                                React.createElement(Checkbox, { disabled: allDayDisabled || (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE, onChange: handleAllDayChange },
                                    React.createElement("span", { className: styles.checkboxContent }, getIn18Text('QUANTIAN')))));
                        })),
                    React.createElement(FormItem, { rules: [
                            {
                                validator: (_, value) => {
                                    const valited = Array.isArray(value) && value.reduce((prev, curv) => prev && verifyEmail(curv === null || curv === void 0 ? void 0 : curv.trim()), true);
                                    const limited = Array.isArray(value) && value.length <= 200;
                                    if (!limited) {
                                        SiriusMessage.error({ content: getIn18Text('SHOUYAOCHENGYUANZONG') });
                                    }
                                    if (valited && limited) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject();
                                },
                            },
                        ], label: React.createElement("i", { className: classnames(eventcontentStyles.icon, eventcontentStyles.member) }), name: "required", normalize: itemList => {
                            if (Array.isArray(itemList)) {
                                return Array.from(new Set(itemList
                                    .map(e => {
                                    if (e.email && typeof e.email === 'string') {
                                        return e.email;
                                    }
                                    return e;
                                })
                                    .filter(e => !!e)));
                            }
                            return [];
                        } },
                        React.createElement(ContactScheduleModal, { includeSelf: true, disabled: (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE, defaultSelectList: defaultContactList || transContactInfo2ContactItem(editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.contactInfo.filter(e => e.originInvtees)), useEdm: isEdm, type: isEdm ? ['customer', 'personal', 'enterprise', 'team', 'recent'] : ['personal', 'enterprise', 'team', 'recent'], dropdownClassName: styles.selectDropDown, listItemHeight: 30, placeholder: getIn18Text('YAOQINGCHENGYUAN'), showSuffix: true, modalProps: {
                                zIndex: 1050,
                                maskStyle: expanded ? { left: 0 } : {},
                            } })),
                    busyOutput !== null && formCurUsers.length > 0 && (React.createElement("p", { className: classnames(styles.busyfree, {
                            [styles.busyfreeAllbusy]: busyOutput.status === 'allBusy',
                            [styles.busyfreeAllfree]: busyOutput.status === 'allFree',
                            [styles.busyfreePartbusy]: busyOutput.status === 'partBusy',
                        }) },
                        React.createElement("span", { className: classnames(styles.busyfreeInner, {
                                [styles.busyfreeInnerExpanded]: expanded,
                            }), onClick: () => !expanded && onExpand && onExpand(!0) },
                            React.createElement("span", null,
                                " ",
                                busyOutput.text),
                            !expanded && React.createElement(ArrowRight, { opcacity: 1, stroke: busyOutput.status === 'allFree' ? '#386ee7' : '#f74f4f' })))),
                    React.createElement(FormItem, { rules: [
                            {
                                validator: (_, value) => {
                                    const originInvitees = new Set(editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.contactInfo.filter(item => item.originInvtees && !item.isOrganizer).map(item => item.email));
                                    const valited = Array.isArray(value) && value.reduce((prev, curv) => prev && verifyEmail(curv === null || curv === void 0 ? void 0 : curv.trim()), true);
                                    if (valited) {
                                        value.forEach(item => {
                                            originInvitees.delete(item);
                                        });
                                    }
                                    const limited = Array.isArray(value) && originInvitees.size + value.length <= 200;
                                    if (!limited) {
                                        SiriusMessage.error({ content: getIn18Text('SHOUYAOCHENGYUANZONG') });
                                    }
                                    if (valited && limited) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject();
                                },
                            },
                        ], label: React.createElement("i", { className: classnames(eventcontentStyles.icon, eventcontentStyles.member) }), name: "moreInvitee", hidden: !editingEvent ||
                            ((_b = (_a = editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo) === null || _a === void 0 ? void 0 : _a.organizer) === null || _b === void 0 ? void 0 : _b.extDesc) === ((_c = sysApi.getCurrentUser()) === null || _c === void 0 ? void 0 : _c.id) ||
                            (editingEvent && ((_d = editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo) === null || _d === void 0 ? void 0 : _d.inviteeType) !== InviteType.INVITEE), normalize: itemList => {
                            if (Array.isArray(itemList)) {
                                return Array.from(new Set(itemList
                                    .map(e => {
                                    if (e.email && typeof e.email === 'string') {
                                        return e.email;
                                    }
                                    return e;
                                })
                                    .filter(e => !!e)));
                            }
                            return [];
                        } },
                        React.createElement(ContactScheduleModal, { includeSelf: true, useEdm: isEdm, defaultSelectList: defaultMoreInvitee, type: isEdm ? ['customer', 'personal', 'enterprise', 'team', 'recent'] : ['personal', 'enterprise', 'team', 'recent'], dropdownClassName: styles.selectDropDown, listItemHeight: 30, placeholder: getIn18Text('TIANJIAGENGDUOSHOUYR'), showSuffix: true, modalProps: {
                                zIndex: 1050,
                                maskStyle: expanded ? { left: 0 } : {},
                            } })),
                    React.createElement(AuthTagFormItem, { authTagProps: {
                            tagName: ProductTagEnum.MEETING_SETTING,
                            tipText: getIn18Text('XIANSHI'),
                            style: {
                                display: 'block',
                            },
                            flowTipStyle: {
                                zIndex: 2,
                            },
                        }, shouldUpdate: (prev, curv) => prev.meetingOrderParam !== curv.meetingOrderParam, label: React.createElement("i", { className: classnames(eventcontentStyles.icon, eventcontentStyles.location) }) }, ({ getFieldsValue, getFieldValue }) => {
                        if (getMeetingCondition(getFieldsValue())) {
                            return (React.createElement(FormItem, { name: "location", noStyle: true },
                                React.createElement(LocationInput, { disabled: (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE, id: "schedule_form_input_location", onCancel: handleCancelMeetingRoom, onUpdate: () => {
                                        onGoSelectMeetingRoom && onGoSelectMeetingRoom();
                                    } })));
                        }
                        return (React.createElement(InputContextMenu, { inputOutRef: didianInputRef, changeVal: val => {
                                form.setFieldsValue({ location: val });
                            } },
                            React.createElement(FormItem, { name: "location", getValueFromEvent: genMaxLenValue({ max: 500, name: getIn18Text('RICHENGDEDIAN') }), noStyle: true },
                                React.createElement(PasteInput, { id: "schedule_form_input_location", disabled: (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE, allowClear: true, placeholder: getIn18Text('RICHENGDEDIAN'), ref: didianInputRef, suffix: meetingRoomExsit && getFieldValue(['moments', 'startDate']) && getFieldValue(['moments', 'endDate']) ? (React.createElement("a", { style: { fontSize: 12 }, onClick: e => {
                                            e.preventDefault();
                                            onGoSelectMeetingRoom && (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) !== InviteType.INVITEE && onGoSelectMeetingRoom();
                                        } }, getIn18Text('XUANZEHUIYISHI'))) : undefined }))));
                    }),
                    React.createElement(FormItem, { hidden: expanded, label: React.createElement("i", { className: classnames(eventcontentStyles.icon, eventcontentStyles.calendar) }), dependencies: [['catalogId']] }, ({ getFieldValue }) => {
                        var _a;
                        return (React.createElement(FormItem, { noStyle: true, name: "catalogId" },
                            React.createElement(Select, { getPopupContainer: formElement, disabled: (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE, onChange: handleChangeCatalog, dropdownClassName: styles.selectDropDown, listItemHeight: 30, suffixIcon: React.createElement("span", { style: { display: 'inline-block', width: '32px', marginLeft: '-18px' } },
                                    !((_a = catalogList.find(c => c.id == getFieldValue('catalogId'))) === null || _a === void 0 ? void 0 : _a.publish) ? (React.createElement(Tooltip, { placement: "top", overlayClassName: "show-arrow", overlayInnerStyle: { fontSize: '12px', maxWidth: '240px' }, title: "\u6B64\u65E5\u5386\u4EC5\u81EA\u5DF1\u53EF\u89C1\uFF0C\u5176\u4ED6\u7528\u6237\u5747\u65E0\u6743\u67E5\u770B\u3002\u8BE5\u65E5\u5386\u7684\u65E5\u7A0B\u5360\u636E\u65F6\u95F4\u6BB5\u5BF9\u5916\u4F1A\u5C55\u793A\u4E3A\u6709\u7A7A" },
                                        React.createElement(QuestionCircleOutlined, { style: { fontSize: 12, marginRight: '8px' } }))) : null,
                                    React.createElement("i", { className: `dark-invert ${styles.expandIcon}` })), style: { width: 200 } }, catalogList.map(s => (React.createElement(Select.Option, { className: styles.selectOption, key: s.id, value: s.id }, s.name))))));
                    }),
                    expanded && React.createElement("p", { style: { marginBottom: 16 } }, getIn18Text('RICHENGXIANGQING')),
                    React.createElement(Form.List, { name: "reminders", initialValue: [] }, (fields, { add, remove }) => (React.createElement(React.Fragment, null,
                        fields.map((_a, i) => {
                            var { key, name } = _a, field = __rest(_a, ["key", "name"]);
                            return (React.createElement(FormItem, { hidden: !expanded, style: { marginBottom: 8 }, key: key, label: React.createElement("i", { className: classnames(eventcontentStyles.icon, {
                                        [eventcontentStyles.bell]: i === 0,
                                    }) }), dependencies: [['time', 'allDay']] }, ({ getFieldValue }) => (React.createElement(React.Fragment, null,
                                getFieldValue(['time', 'allDay']) ? (React.createElement(FormItem, Object.assign({}, field, { name: [name, 'beforeOpt'], initialValue: getFieldValue(['reminders', name, 'interval']) === 0 ? 'current' : 'before', noStyle: true }),
                                    React.createElement(Select, { onChange: v => handleBeforeOptChange(v, name), dropdownClassName: styles.selectDropDown, className: styles.selectLabel, style: { width: 55, padding: 0, fontSize: 14 }, suffixIcon: React.createElement("i", { className: `dark-invert ${styles.expandIcon}` }), bordered: false },
                                        React.createElement(Select.Option, { className: styles.selectOption, key: 'before', value: 'before' }, getIn18Text('TIQIAN')),
                                        React.createElement(Select.Option, { className: styles.selectOption, key: 'current', value: 'current' }, getIn18Text('DANG1'))))) : (React.createElement("span", { style: { width: 55, marginRight: 12 } }, getIn18Text('TIQIAN'))),
                                React.createElement(FormItem, { dependencies: [[name, 'beforeOpt']], noStyle: true }, () => {
                                    const isCurrent = getFieldValue(['reminders', name, 'beforeOpt']) === 'current';
                                    const timeUnit = getFieldValue(['reminders', name, 'timeUnit']);
                                    const interval = getFieldValue(['reminders', name, 'interval']);
                                    let maxLength = ReminderTimeUnit.DAY === timeUnit ? 7 : ReminderTimeUnit.HOUR === timeUnit ? 24 : 60;
                                    if (!isCurrent) {
                                        return (React.createElement(React.Fragment, null,
                                            React.createElement(FormItem, Object.assign({}, field, { name: [name, 'interval'], initialValue: 1, noStyle: true }),
                                                React.createElement(InputNumber, { max: maxLength, min: 1, onChange: v => handleIntervalChange(v, name), style: { borderRadius: 4, width: 80, marginRight: 12 } })),
                                            React.createElement(FormItem, Object.assign({}, field, { name: [name, 'timeUnit'], noStyle: true }),
                                                React.createElement(Select, { getPopupContainer: formElement, dropdownClassName: styles.selectDropDown, listItemHeight: 30, onChange: v => handleIntervalChange(interval, name), suffixIcon: React.createElement("i", { className: `dark-invert ${styles.expandIcon}` }), style: { width: 80, marginRight: 12 } }, reminderTimeUnitOpts(getFieldValue(['time', 'allDay'])).map(op => (React.createElement(Select.Option, { className: styles.selectOption, key: op.value, value: op.value }, op.label)))))));
                                    }
                                    else {
                                        return null;
                                    }
                                }),
                                getFieldValue(['time', 'allDay']) ? (React.createElement(FormItem, Object.assign({}, field, { name: [name, 'time', 'hr'], initialValue: 8, noStyle: true }),
                                    React.createElement(Select, { dropdownClassName: styles.selectDropDown, style: { width: 80, marginRight: 12, padding: 0 }, suffixIcon: React.createElement("i", { className: `dark-invert ${styles.expandIcon}` }) }, Array.from({ length: 24 }, (_, index) => index.toString().padStart(2, '0')).map((e, i) => (React.createElement(Select.Option, { className: styles.selectOption, key: i, value: i }, `${e}:00`)))))) : null,
                                React.createElement(FormItem, { dependencies: [[name, 'timeUnit']], noStyle: true }, () => {
                                    const interval = getFieldValue(['reminders', name, 'interval']);
                                    const timeUnit = getFieldValue(['reminders', name, 'timeUnit']);
                                    const disableAppReminder = ReminderTimeUnit.WEEK === timeUnit && interval > 4;
                                    return (React.createElement(FormItem, Object.assign({}, field, { name: [name, 'reminderAction'], initialValue: ReminderAction.EMAIL_APP, noStyle: true }),
                                        React.createElement(Select, { getPopupContainer: formElement, dropdownClassName: styles.selectDropDown, listItemHeight: 30, suffixIcon: React.createElement("i", { className: `dark-invert ${styles.expandIcon}` }), style: { width: 140, marginRight: 12 } }, reminderActionOpts().map(op => (React.createElement(Select.Option, { className: styles.selectOption, key: op.value, value: op.value, disabled: op.value !== ReminderAction.EMAIL && disableAppReminder }, op.label))))));
                                }),
                                React.createElement("i", { onClick: () => remove(name), className: classnames('dark-invert', eventcontentStyles.icon, eventcontentStyles.close) })))));
                        }),
                        expanded && fields.length < 20 && (React.createElement(FormItem, { noStyle: true, dependencies: [['time', 'allDay']] }, ({ getFieldValue }) => {
                            const allDay = getFieldValue(['time', 'allDay']);
                            const handleAdd = () => {
                                const reminder = getReminderByDefaultReminderAction(allDay);
                                add(reminder);
                            };
                            return (React.createElement(React.Fragment, null,
                                React.createElement("i", { className: classnames(eventcontentStyles.icon, {
                                        [eventcontentStyles.bell]: fields.length === 0,
                                    }) }),
                                React.createElement("button", { type: "button", className: styles.abutton, onClick: handleAdd }, getIn18Text('TIANJIATIXING'))));
                        }))))),
                    React.createElement(FormItem, { hidden: !expanded, label: React.createElement("i", { className: classnames(eventcontentStyles.icon, eventcontentStyles.calendar) }), dependencies: [['catalogId']] }, ({ getFieldValue }) => {
                        var _a;
                        return (React.createElement(FormItem, { noStyle: true, name: "catalogId" },
                            React.createElement(Select, { getPopupContainer: formElement, disabled: (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE, onChange: handleChangeCatalog, dropdownClassName: styles.selectDropDown, listItemHeight: 30, suffixIcon: React.createElement("span", { style: { display: 'inline-block', width: '32px', marginLeft: '-18px' } },
                                    !((_a = catalogList.find(c => c.id == getFieldValue('catalogId'))) === null || _a === void 0 ? void 0 : _a.publish) ? (React.createElement(Tooltip, { placement: "top", overlayClassName: "show-arrow", overlayInnerStyle: { fontSize: '12px', maxWidth: '240px' }, title: "\u6B64\u65E5\u5386\u4EC5\u81EA\u5DF1\u53EF\u89C1\uFF0C\u5176\u4ED6\u7528\u6237\u5747\u65E0\u6743\u67E5\u770B\u3002\u8BE5\u65E5\u5386\u7684\u65E5\u7A0B\u5360\u636E\u65F6\u95F4\u6BB5\u5BF9\u5916\u4F1A\u5C55\u793A\u4E3A\u6709\u7A7A" },
                                        React.createElement(QuestionCircleOutlined, { style: { fontSize: 12, marginRight: '8px' } }))) : null,
                                    React.createElement("i", { className: `dark-invert ${styles.expandIcon}` })), style: { width: 200 } }, catalogList.map(s => (React.createElement(Select.Option, { className: styles.selectOption, key: s.id, value: s.id }, s.name))))));
                    }),
                    React.createElement(FormItem, { hidden: !expanded, label: React.createElement("i", { className: classnames(eventcontentStyles.icon, eventcontentStyles.eyes) }), dependencies: [['clazz', 'transp', 'catalogId']] }, ({ getFieldValue }) => {
                        var _a, _b, _c, _d;
                        return (React.createElement(React.Fragment, null,
                            React.createElement(FormItem, { noStyle: true, name: "clazz" },
                                React.createElement(Select, { getPopupContainer: formElement, dropdownClassName: styles.selectDropDown, listItemHeight: 30, disabled: ((_a = catalogList.find(c => c.id == getFieldValue('catalogId'))) === null || _a === void 0 ? void 0 : _a.privilege) == 1, suffixIcon: React.createElement("span", { style: { display: 'inline-block', width: '32px', marginLeft: '-18px' } },
                                        React.createElement(Tooltip, { placement: "top", overlayClassName: "show-arrow", overlayInnerStyle: { fontSize: '12px', maxWidth: '240px' }, title: (_b = clazzMap.find(m => m.value == getFieldValue('clazz'))) === null || _b === void 0 ? void 0 : _b.tipTitle },
                                            React.createElement(QuestionCircleOutlined, { style: { fontSize: 12, marginRight: '8px' } })),
                                        React.createElement("i", { className: `dark-invert ${styles.expandIcon}` })), style: { width: 200, marginRight: 12 } }, clazzMap.map(v => (React.createElement(Select.Option, { className: styles.selectOption, key: v.value, value: v.value }, v.label))))),
                            React.createElement(FormItem, { noStyle: true, name: "transp" },
                                React.createElement(Select, { getPopupContainer: formElement, dropdownClassName: styles.selectDropDown, listItemHeight: 30, disabled: ((_c = catalogList.find(c => c.id == getFieldValue('catalogId'))) === null || _c === void 0 ? void 0 : _c.privilege) == 1, suffixIcon: React.createElement("span", { style: { display: 'inline-block', width: '32px', marginLeft: '-18px' } },
                                        React.createElement(Tooltip, { placement: "top", overlayClassName: "show-arrow", overlayInnerStyle: { fontSize: '12px', maxWidth: '240px' }, title: (_d = busyStatus.find(m => m.value == getFieldValue('transp'))) === null || _d === void 0 ? void 0 : _d.tipTitle },
                                            React.createElement(QuestionCircleOutlined, { style: { fontSize: 12, marginRight: '8px' } })),
                                        React.createElement("i", { className: `dark-invert ${styles.expandIcon}` })), style: { width: 100 } }, busyStatus.map(b => (React.createElement(Select.Option, { className: styles.selectOption, key: b.value, value: b.value }, b.label)))))));
                    }),
                    React.createElement(FormItem, { hidden: !expanded, getValueFromEvent: genMaxLenValue({ max: 2000, name: getIn18Text('RICHENGMIAOSHU') }), label: React.createElement("i", { className: classnames(eventcontentStyles.icon, eventcontentStyles.message) }), className: styles.descEditorWrap, name: "description" },
                        React.createElement(Form.Item, { noStyle: true, dependencies: ['description'] }, ({ getFieldValue }) => {
                            return (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "content-editor-mask", style: { display: (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE ? 'block' : 'none' } }),
                                React.createElement(DescEditor, { originContent: getFieldValue('description'), editorChange: editorChange, editorBlur: editorBlur, getEditorInstance: getEditorInstance, isWarn: overLimit, disabled: (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE }),
                                React.createElement("div", { className: "content-editor-limit" }, overLimit && `最多输入${limitWordCount}个字符`)));
                        })),
                    React.createElement(FormItem, { hidden: !expanded, label: React.createElement("i", { className: classnames(eventcontentStyles.icon, eventcontentStyles.attachment) }), name: "attachments" },
                        React.createElement(ScheduleUploadFile, { disabled: (editingEvent === null || editingEvent === void 0 ? void 0 : editingEvent.scheduleInfo.inviteeType) === InviteType.INVITEE })),
                    React.createElement(FormItem, { noStyle: true, hidden: true, name: "color" },
                        React.createElement(Input, null)),
                    React.createElement(FormItem, { noStyle: true, hidden: true, name: "meetingOrderParam" },
                        React.createElement(Input, null)),
                    React.createElement(FormItem, { noStyle: true, hidden: true, name: "rruleUntil" },
                        React.createElement(Input, null)),
                    React.createElement(FormItem, { noStyle: true, hidden: true, name: "count" },
                        React.createElement(Input, null)),
                    React.createElement(FormItem, { noStyle: true, hidden: true, name: "interval" },
                        React.createElement(Input, null)),
                    React.createElement(FormItem, { noStyle: true, hidden: true, name: "byDay" },
                        React.createElement(Input, null)),
                    React.createElement(FormItem, { noStyle: true, hidden: true, name: "byMonthDay" },
                        React.createElement(Input, null)),
                    React.createElement(FormItem, { noStyle: true, hidden: true, name: "byMonth" },
                        React.createElement(Input, null)),
                    React.createElement(FormItem, { noStyle: true, hidden: true, name: "bySetPos" },
                        React.createElement(Input, null))))),
        React.createElement(MeetingRoomUntilTip, { onReselectDateTime: handleCancelMeetingRoom, type: meetingTipType, onReselectMeetingRoom: () => {
                form.setFieldsValue({ rruleUntil: undefined });
                setMeetingTipType(undefined);
                onGoSelectMeetingRoom && onGoSelectMeetingRoom();
            }, untilDateTime: untilDateTimeTemp, getReferenceElement: () => {
                if (meetingTipType === 'until_error') {
                    return document.getElementById('schedule_form_select_rrule');
                }
                return document.getElementById('schedule_form_input_location');
            }, onOk: until => {
                if (until) {
                    const [prevRule] = form.getFieldValue('enmuRecurrenceRule').split('/');
                    const changedValues = {
                        rruleUntil: until,
                        count: undefined,
                        enmuRecurrenceRule: `${prevRule}/${EnmuRecurrenceRule.TEMP_INSERT}`,
                    };
                    const allValues = Object.assign(Object.assign({}, form.getFieldsValue()), changedValues);
                    form.setFieldsValue(changedValues);
                    const actRules = baseLoopRules.slice();
                    const _a = cloneDeep(allValues), { count } = _a, rest = __rest(_a, ["count"]);
                    const label = getRecurIntro(rest);
                    actRules.push({
                        value: `${prevRule}/${EnmuRecurrenceRule.TEMP_INSERT}`,
                        label,
                    });
                    setLoopRules(actRules);
                    setMeetingTipType(undefined);
                    handleValuesChange(changedValues, allValues);
                }
            } }),
        React.createElement("div", { className: classnames(styles.bottom, {
                [styles.bottomBordered]: expanded,
                [styles.bottomUnexpanded]: !expanded,
            }) },
            !expanded && React.createElement(ExpandButton, { onClick: handleExpand }, getIn18Text('GENGDUOXUANXIANG')),
            renderSaveBtn())));
};
export default React.forwardRef(SchduleForm);
